import { Component, OnInit } from '@angular/core';
import { CosyGridComponent } from '../../../cosy-grid.component';
@Component({
  selector: 'app-cosy-grid-rowdetail-view',
  templateUrl: './cosy-grid-rowdetail-view.component.html',
  styleUrls: ['./cosy-grid-rowdetail-view.component.css']
})
export class CosyGridRowdetailViewComponent implements OnInit {

  parent!: CosyGridComponent;
  model!: {
    ID: string;
  };
  gridRowHiddenDetails: {header:string, value:any}[]=[];
  //grid: any;
  //dataView: any;
 
  constructor() { }

  ngOnInit(): void { 
    for(let column of this.parent.updatedColumnDefinitions){
      if(column.minWidth == -1){
        this.gridRowHiddenDetails.push({header: column.name, value: this.model[column.id]});
      }
    }
  }
}
